import { render, staticRenderFns } from "./GSbyManager.vue?vue&type=template&id=634c6950&scoped=true&"
import script from "./GSbyManager.vue?vue&type=script&lang=js&"
export * from "./GSbyManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634c6950",
  null
  
)

export default component.exports